import React from "react";
import {
  HeaderConfig,
  IntroContentConfig,
  IntroThemeConfig,
  appliedConfig,
} from "../config/commonConfig";
import WhatsAppButton from "./WhatsAppButton";
const AboutUs = () => {
  return (
    <section
      id="about"
      className={
        "section " +
        (appliedConfig.appliedHeader === HeaderConfig.SideHeaderDark ||
        appliedConfig.appliedHeader === HeaderConfig.SideHeaderLight
          ? "px-lg-4 "
          : " ")
      }
    >
      <div
        className={
          "container " +
          (appliedConfig.appliedIntro === IntroThemeConfig.Intro1 &&
          appliedConfig.appliedIntroContent === IntroContentConfig.Image
            ? "pt-5 "
            : " ")
        }
      >
        <h2 className="text-9 fw-600 text-center">Como Funciona?</h2>
        <hr className="heading-separator-line bg-primary opacity-10 mx-auto" />
        <p className="lead lh-base text-center mb-4" style={{ maxWidth: '920px', margin: '0 auto' }}>
          Modelo de revenda sem burocracia: <br />Não é franquia, não exige investimento inicial, e não é sistema de afiliados.
        </p>
        <div className="row">
          <div className="col-lg-6 text-center">
            {" "}
            <img className="img-fluid" src="images/Imagem1.jpeg" alt="About me" style={{ maxHeight: '400px' }} />{" "}
          </div>
          <div className="col-lg-6 text-center text-lg-start">
            <h5>Nosso diferencial é um modelo simples, lucrativo e escalável</h5>
            <p>
              Você tem a sua própria operação de revenda de cursos, com autonomia e suporte.
Plataforma completa: pronta para você oferecer cursos de formação, atualização e qualificação para motoristas profissionais em todo o Brasil.
Cursos especializados: conteúdos atualizados e reconhecidos no mercado de trânsito.

            </p>
            <WhatsAppButton />
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutUs;
